import { createContext, CSSProperties, Dispatch, SetStateAction } from 'react';

type TContext = {
	id: string;
	data: any;
	setData: Dispatch<SetStateAction<{ [key: string]: any }>> | null;
	getStyles: (returnRaw?: boolean) => Record<string, number> | CSSProperties;
}

export const ContextMenuContext = createContext<TContext>({
	id: '',
	data: null,
	setData: null,
	getStyles: () => { return { x: 0, y: 0 } }
});
